export default __webpack_public_path__ + "static/media/Cover.7e1ffc16.svg";